module.exports = __webpack_public_path__ + "img/ladder.be5030ca.webp";